import React, { useEffect } from 'react';
import './QuoteBanner.scss';

const QuoteBanner = () => {
  useEffect(() => {
    const handleScroll = () => {
      const banner = document.querySelector('.quote-banner');
      const rect = banner.getBoundingClientRect();
      const scrollY = window.scrollY;
      if (rect.top <= window.innerHeight && rect.bottom >= 0) {
        banner.style.backgroundPositionY = `${(scrollY - rect.top) * 0.5}px`;
      } else {
        banner.style.backgroundPositionY = 'top';
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="quote-banner">
      <div className="quote-container">
        <div className="stars">★★★★★</div>
        <p className="quote">"Excellent service from start to finish. Lovely approachable people who kept us informed throughout the process."</p>
        <div className="reviewer-info">
          <span className="reviewer-name">Julie</span>
          <span className="review-source">Google</span>
        </div>
      </div>
    </div>
  );
};

const QuoteBannerTwo = () => {
  useEffect(() => {
    const handleScroll = () => {
      const banner = document.querySelector('.quote-banner-two');
      const rect = banner.getBoundingClientRect();
      const scrollY = window.scrollY;
      if (rect.top <= window.innerHeight && rect.bottom >= 0) {
        banner.style.backgroundPositionY = `${(scrollY - rect.top) * 0.5}px`;
      } else {
        banner.style.backgroundPositionY = 'top';
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="quote-banner-two">
      <div className="quote-container">
        <div className="stars">★★★★★</div>
        <p className="quote">"Amazing support and guidance throughout the entire process. Highly recommend!"</p>
        <div className="reviewer-info">
          <span className="reviewer-name">John</span>
          <span className="review-source">Google</span>
        </div>
      </div>
    </div>
  );
};

export { QuoteBanner, QuoteBannerTwo };

